import React from 'react';
import { Table, Button } from 'reactstrap';
import moment from 'moment-timezone';
function createMarkup() {
  return { __html: 'First &middot; Second' };
}
const ContractTable = props => {
  return (
    <Table responsive hover className="ps-table tb-col-8">
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Product</th>
          <th>Total Sessions</th>
          <th>Left Sessions</th>
          <th>Start Contract</th>
          <th>End Contract</th>
          <th>Last Service</th>
          <th>Due</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {props.state.contract.length < 1 && (
          <tr>
            <td colSpan="11">
              <div className="ps-empty-data">
                <div className="empty-content">
                  <h4>No data to show</h4>
                </div>
              </div>
            </td>
          </tr>
        )}

        {props.state.contract.length > 0 &&
          props.state.contract.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.order_id}</td>
                <td>{item.product}</td>
                <td>{item.total_sessions}</td>
                <td>{item.left_sessions}</td>
                <td>
                  {moment(item.start_dt)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD')}
                </td>
                <td>
                  {moment(item.end_dt)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD')}
                </td>
                <td>
                  {moment(item.last_service_dt)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD')}
                </td>
                <td>
                  {moment(item.due_dt)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD')}
                </td>
                <td>
                  <Button
                    className="theme-button theme-button-secondary"
                    onClick={props.toggle(
                      item.order_id,
                      item.left_sessions,
                      moment(item.end_dt)
                        .tz('Asia/Singapore')
                        .format('YYYY-MM-DD'),
                    )}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default ContractTable;
